module.exports = __webpack_public_path__ + "img/ic_profile_wizard_professional_reference.03557720.svg";